const CPF_LENGTH: number = 11;

export const cpfMask = '000.000.000-00';
export const cpfOfTransitionMask = 'AAA.AAA.AAA-AA';

export const cnpjMask = 'AA.AAA.AAA/AAAA-00';
export const cpfOrCnpjMask = `${cpfOfTransitionMask}||${cnpjMask}`;

export function cpfCnpjMask(userInput: string): string {
  let cleanInput = (userInput || '')
    .split('')
    .filter((char) => !/[./\-\s]/.test(char))
    .join('');
  cleanInput = cleanInput.toUpperCase();
  const hasLetter = /[A-Z]/i.test(cleanInput);

  if (hasLetter) {
    return cnpjMask;
  }

  if (cleanInput.length < CPF_LENGTH - 1) {
    return cpfOfTransitionMask;
  }

  if (cleanInput.length <= CPF_LENGTH) {
    return cpfOrCnpjMask;
  }

  return cnpjMask;
}
